import TokenManager from '@tekion/tap-components/utils/TokenManager';
import { doGet, doPost } from '../services/http';
import { getUserPreference, postUpdateNotification, postUpdateSummary } from './urls';

const email = TokenManager.getItem('email');
export const fetchPreferencesApi = url => doGet(`${url}${getUserPreference}${email}`);
export const updateNotificationApi = (url, data) => doPost(`${url}${postUpdateNotification}`, data);
export const updateSummaryApi = (url, data) => doPost(`${url}${postUpdateSummary}`, data);
